import api from "./api";
import FormData,{Headers} from 'form-data';

class ClientApi {
    static register = async (body: {}) => {
        const response = await api.post(`/Cliente`, body);
        return response.data;
    };

    static getClients = async (page: Number, RecordsPerPage: Number, Search: any) => {
        const response = await api.get(`/Cliente?Page=${page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}`);
        return response;
    };

    static getClientPerId = async (idCliente: Number) => {
        const response = await api.get(`/Cliente/${idCliente}`);
        return response.data;
    };
    static updateClientPerId = async (idCliente: Number, obj: any) => {
        const response = await api.put(`/Cliente/${idCliente}`, obj);
        return response.data;
    };
    static deleteClientPerId = async (idCliente: Number) => {
        const response = await api.delete(`/Cliente/${idCliente}`);
        return response.data;
    };

    static registerClientCredentials = async (idCliente: Number, obj: any) => {
        const response = await api.post(`/Cliente/${idCliente}/Credenciais`, obj);
        return response.data;
    };

    static getClientCredentials = async (idCliente: Number, page: Number, RecordsPerPage: Number) => {
        const response = await api.get(`/Cliente/${idCliente}/Credenciais?Page=${page}&RecordsPerPage=${RecordsPerPage}`);
        return response;
    };

    static deleteClientCredentialsPerId = async (idCliente: Number, idCredential: Number) => {
        const response = await api.delete(`/Cliente/${idCliente}/Credenciais/${idCredential}`);
        return response.data;
    };

    static registerClientAccount = async (idCliente: Number, obj: any) => {
        const response = await api.post(`/Cliente/${idCliente}/Contas`, obj);
        return response.data;
    };

    static getClientAccounts = async (idCliente: Number, page: Number, RecordsPerPage: Number) => {
        const response = await api.get(`/Cliente/${idCliente}/Contas?Page=${page}&RecordsPerPage=${RecordsPerPage}`);
        return response;
    };

    static deleteClientAccountPerId = async (idCliente: Number, idAccount: Number) => {
        const response = await api.delete(`/Cliente/${idCliente}/Contas/${idAccount}`);
        return response.data;
    };

    static registerClientContacts = async (idCliente: Number, obj: any) => {
        const response = await api.post(`/Cliente/${idCliente}/Contatos`, obj);
        return response.data;
    };

    static getClientContacts = async (idCliente: Number, page: Number, RecordsPerPage: Number) => {
        const response = await api.get(`/Cliente/${idCliente}/Contatos?Page=${page}&RecordsPerPage=${RecordsPerPage}`);
        return response;
    };

    static deleteClientContactPerId = async (idCliente: Number, idContact: Number) => {
        const response = await api.delete(`/Cliente/${idCliente}/Contatos/${idContact}`);
        return response.data;
    };

    static getClientDocuments = async (idCliente: Number, page: Number, RecordsPerPage: Number) => {
        const response = await api.get(`/Cliente/${idCliente}/Documentos?Page=${page}&RecordsPerPage=${RecordsPerPage}`);
        return response;
    };

    static deleteClientDocumentPerId = async (idCliente: Number, idDocument: Number) => {
        const response = await api.delete(`/Cliente/${idCliente}/Documentos/${idDocument}`);
        return response.data;
    };

    static postClientDocuments = async (idCliente: Number, idTipoDocument: Number, document: any) => {
        let form: any = new FormData();
        form.append("file", document)
        const response = await api.post(`Cliente/${idCliente}/Documentos/${idTipoDocument}`, form)
        return response
    };

    static getClientDocumentById = async (idCliente: Number, idDocument: Number) => {
        const response = await api.get(`/Cliente/${idCliente}/Documentos/${idDocument}`, {
            responseType: 'blob',
        });
        return response.data;
    };

    static ativarCliente = async (idCliente: Number) => {
        const response = await api.patch(`/Cliente/${idCliente}/Ativar`);
        return response.data;
    };

    static desativarCliente = async (idCliente: Number) => {
        const response = await api.patch(`/Cliente/${idCliente}/Desativar`);
        return response.data;
    };

};

export default ClientApi;